export default "__VITE_ASSET__BTi6ejiH__"